module.exports = "<div class=date-time-stage :class=[themeClass]> <div class=date-time-box @click.stop> <input :placeholder=placeholder v-el:input v-model=value v-datetimepicker=\"{config: config}\"/> <icon class=calendar-icon name=calendar></icon> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/common/components/common/date-time/date-time.tpl
// module id = 952
// module chunks = 2